import type { SortToggle } from '@components/SortSelect/SortButton';
import { useLibraryManager } from '@stores/LibraryManager/LibraryManager';
import { trackingStore } from '@stores/Tracking';
import { PINNED_FIRST_LABEL } from '../utils/sortOptions';

/**
 * The whole "Pinned first" control — label, current state, and what a flip does — for both sort
 * pickers.
 *
 * Shared rather than written out per caller because the two call sites are otherwise identical
 * down to the tracking call, and the wrong half of that being updated in one place only is the
 * exact drift `PINNED_FIRST_LABEL` was extracted to prevent.
 *
 * Lives here rather than beside that constant in `utils/sortOptions.ts`: this needs `React` and
 * two stores, and dragging those into that module would make its pure sort-hash converters
 * unimportable by the repo's standalone `npx tsx` test runner.
 *
 * Call from an `observer` component — `checked` is read from an observable.
 */
export function usePinnedFirstToggle(): SortToggle {
  const libraryManager = useLibraryManager();

  return {
    label: PINNED_FIRST_LABEL,
    checked: libraryManager.pinnedFirst,
    onChange: (checked) => {
      libraryManager.setPinnedFirst(checked);
      trackingStore.libraryPinnedFirstToggled({ enabled: checked });
    },
  };
}
